import { useHistory } from 'react-router';
import useIterationSummaryEventsTracker from './useIterationSummaryEventsTracker';
import useQueryParams from 'components/hooks/useQueryParams';

const useCloseIterationSummary = () => {
  const history = useHistory();
  const urlParams = new URLSearchParams(window.location.search);
  const tracker = useIterationSummaryEventsTracker();
  const { useQueryParam } = useQueryParams();
  const isIterationSummaryOpen = useQueryParam('iteration_summary');

  const onCloseIterationSummary = () => {
    if (!isIterationSummaryOpen) return;

    tracker.onClose();
    urlParams.delete('iteration_summary');
    history.replace({ search: urlParams.toString() });
  };

  return { onCloseIterationSummary };
};

export default useCloseIterationSummary;
